<template>
  <v-app-bar
    absolute
    color="#FFFF"
    dark
    shrink-on-scroll
    prominent
    fade-img-on-scroll
    scroll-target="#scrolling-techniques-3"
    class="fixed-top"
  >
  
    <v-img
      alt="Vuetify Logo"
      class="shrink mr-2"
      contain
      :src="require('@/assets/logo.png')"
    />

    <v-img />

    <template v-slot:extension>
  <v-tabs class="d-flex justify-center align-center">
    <v-tab @click="navigateTo('/')" class="black--text">
      <v-icon class="black--text">mdi-home</v-icon> Home
    </v-tab>
    <v-tab @click="navigateTo('/electricity')" class="black--text">
      <v-icon class="black--text">mdi-flash</v-icon> Electricidad
    </v-tab>
    <v-tab @click="navigateTo('/plumbing')" class="black--text">
      <v-icon class="black--text">mdi-water</v-icon> Fontanería
    </v-tab>
    <v-tab @click="navigateTo('/reforms')" class="black--text">
      <v-icon class="black--text">mdi-hammer</v-icon> Reformas
    </v-tab>
  </v-tabs>
</template>
    
  </v-app-bar>
</template>

<script>
import sideAlert from "./sideAlert.vue";
import formulario from "./form.vue";
import cardPresentationVue from "./cardPresentation.vue";
import carrusel from "./carrusel.vue";

export default {
  components: {
    carrusel,
    cardPresentationVue,
    formulario,
    "side-alert": sideAlert,
  },
  data() {
    return {
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4",
      ],
      slides: ["First", "Second", "Third", "Fourth", "Fifth"],
    };
  },
  methods: {
    navigateTo(route) {
      if (this.$route.path !== route) {
        this.$router.push(route);
      }
    },
  },
};
</script>
